import { createContext, FC, ReactNode, useContext } from 'react';

export type ServerVarsContextType = {
    isDesktop?: boolean | null;
    isMobile?: boolean | null;
    isSbAdsEnabled?: boolean | null;
    isTablet?: boolean | null;
    clientConf?: { [key: string]: string | number | undefined } | null;
    localeOrigin?: string | null;
    isSearchQueryApplied?: boolean | null;
    isSmallerSbCategoryTilesVariant?: boolean | null;
    locale?: string | null;
    isPdpDesktopSiderailRedesign?: boolean | null;
    isPdpRespSiderailRedesign?: boolean | null;
    isSoldItemLinksPDPVariant?: boolean | null;
    isAuctionSiderailRedesignVariant?: boolean | null;
    isPdpLiveChatVariant?: boolean | null;
    isEnhancedBuyerIncentivesVariant?: boolean | null;
};

export const ServerVarsContext = createContext<ServerVarsContextType>({
    isDesktop: null,
    isMobile: null,
    isSbAdsEnabled: null,
    isTablet: null,
    clientConf: {},
    localeOrigin: null,
    locale: null,
    isSearchQueryApplied: null,
    isSmallerSbCategoryTilesVariant: null,
    isPdpDesktopSiderailRedesign: null,
    isPdpRespSiderailRedesign: null,
    isSoldItemLinksPDPVariant: null,
    isAuctionSiderailRedesignVariant: null,
    isPdpLiveChatVariant: null,
    isEnhancedBuyerIncentivesVariant: null,
});

export const useServerVarsContext = (): ServerVarsContextType => useContext(ServerVarsContext);

export const ServerVarsContextConsumer = ServerVarsContext.Consumer;

export const ServerVarsContextProvider: FC<ServerVarsContextType & { children: ReactNode }> = ({
    children,
    isDesktop,
    isMobile,
    isSbAdsEnabled,
    isTablet,
    clientConf,
    localeOrigin,
    isSearchQueryApplied,
    isSmallerSbCategoryTilesVariant,
    locale,
    isPdpDesktopSiderailRedesign,
    isPdpRespSiderailRedesign,
    isSoldItemLinksPDPVariant,
    isAuctionSiderailRedesignVariant,
    isPdpLiveChatVariant,
    isEnhancedBuyerIncentivesVariant,
}) => {
    return (
        <ServerVarsContext.Provider
            value={{
                isDesktop,
                isMobile,
                isSbAdsEnabled,
                isTablet,
                clientConf,
                localeOrigin,
                isSearchQueryApplied,
                isSmallerSbCategoryTilesVariant,
                locale,
                isPdpDesktopSiderailRedesign,
                isPdpRespSiderailRedesign,
                isSoldItemLinksPDPVariant,
                isAuctionSiderailRedesignVariant,
                isPdpLiveChatVariant,
                isEnhancedBuyerIncentivesVariant,
            }}
        >
            {children}
        </ServerVarsContext.Provider>
    );
};
